/* Mewbie theme — original code. No dependencies. */
(function () {
  'use strict';
  var M = window.Mewbie || (window.Mewbie = {});
  var routes = M.routes || { cart_add: '/cart/add.js', cart: '/cart.js', cart_change: '/cart/change.js' };
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || M.moneyFormat || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, d, t, dec) {
      var s = (n / 100).toFixed(d), parts = s.split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(re), v;
    if (!m) return (cents / 100).toFixed(2);
    switch (m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2, ',', '.');
    }
    return format.replace(re, v);
  }
  M.formatMoney = formatMoney;

  /* ---------- Bundle maths (shared by product form and cart check) ---------- */
  // tiers: [{qty, total (cents|null)}]; unit: unit price in cents. Returns discount for a bundle tier.
  function tierDiscount(tier, unit) {
    if (!tier || tier.total == null) return 0;
    return Math.max(0, tier.qty * unit - tier.total);
  }
  // Shopify applies the best eligible automatic discount; mirror that for a cart quantity.
  function expectedDiscount(tiers, qty, unit) {
    var best = 0;
    (tiers || []).forEach(function (t) { if (qty >= t.qty) best = Math.max(best, tierDiscount(t, unit)); });
    return best;
  }
  M.expectedDiscount = expectedDiscount;

  /* ---------- Gallery ---------- */
  function Gallery(root) {
    this.root = root;
    this.track = $('[data-gallery-track]', root);
    this.slides = $$('[data-gallery-slide]', root);
    this.thumbs = $$('[data-gallery-thumb]', root);
    this.dots = $$('[data-gallery-dot]', root);
    this.prev = $('[data-gallery-prev]', root);
    this.next = $('[data-gallery-next]', root);
    this.index = 0;
    var self = this;
    if (!this.track || this.slides.length === 0) return;
    if (this.prev) this.prev.addEventListener('click', function () { self.go(self.index - 1); });
    if (this.next) this.next.addEventListener('click', function () { self.go(self.index + 1); });
    this.thumbs.forEach(function (t, i) { t.addEventListener('click', function () { self.go(i); }); });
    var raf;
    this.track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = self.track.clientWidth || 1;
        self.setActive(Math.round(self.track.scrollLeft / w));
      });
    }, { passive: true });
    this.setActive(0);
  }
  Gallery.prototype.go = function (i) {
    i = Math.max(0, Math.min(this.slides.length - 1, i));
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    this.setActive(i);
  };
  Gallery.prototype.goToMedia = function (mediaId) {
    if (!mediaId) return;
    for (var i = 0; i < this.slides.length; i++) {
      if (String(this.slides[i].getAttribute('data-media-id')) === String(mediaId)) { this.go(i); return; }
    }
  };
  Gallery.prototype.setActive = function (i) {
    this.index = i;
    this.thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    this.dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    if (this.prev) this.prev.disabled = i === 0;
    if (this.next) this.next.disabled = i === this.slides.length - 1;
    var th = this.thumbs[i];
    if (th && th.parentNode && th.parentNode.scrollTo) {
      th.parentNode.scrollTo({ left: Math.max(0, th.offsetLeft - 40), behavior: 'auto' });
    }
  };

  /* ---------- Product form with bundle selector ---------- */
  function ProductForm(root) {
    var json = $('[data-product-json]', root);
    if (!json) return;
    this.root = root;
    this.data = JSON.parse(json.textContent);
    this.variants = this.data.variants || [];
    this.tiers = this.data.tiers || [];
    this.hasVariants = !!this.data.has_variants;
    this.optionName = this.data.option_name || 'Color';
    this.unitLabel = this.data.unit_label || 'Item';
    this.swatches = this.data.swatches || {};
    this.gallery = root.__gallery;
    this.cards = $$('[data-tier]', root);
    this.atc = $('[data-atc]', root);
    this.atcLabel = $('[data-atc-label]', root);
    this.atcPrice = $('[data-atc-price]', root);
    this.error = $('[data-form-error]', root);
    this.priceNow = $('[data-price-now]', root);
    this.priceWas = $('[data-price-was]', root);
    this.priceOff = $('[data-price-off]', root);
    this.sticky = document.querySelector('[data-sticky="' + root.id + '"]');
    var first = this.variants.filter(function (v) { return v.available; })[0] || this.variants[0];
    this.defaultVariant = first;
    var checked = $('[data-tier-radio]:checked', root);
    this.tierIndex = checked ? Number(checked.value) : 0;
    this.selections = [];
    this.fillSelections();
    var self = this;
    $$('[data-tier-radio]', root).forEach(function (r) {
      r.addEventListener('change', function () { self.tierIndex = Number(r.value); self.fillSelections(); self.render(); });
    });
    var form = $('form.mb-form', root);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); self.add(); });
    if (this.sticky) {
      var sb = $('[data-sticky-add]', this.sticky);
      if (sb) sb.addEventListener('click', function () { self.add(); });
      this.watchSticky();
    }
    this.render();
  }
  ProductForm.prototype.tier = function () { return this.tiers[this.tierIndex] || { qty: 1, total: null }; };
  ProductForm.prototype.variantById = function (id) {
    for (var i = 0; i < this.variants.length; i++) if (String(this.variants[i].id) === String(id)) return this.variants[i];
    return null;
  };
  ProductForm.prototype.fillSelections = function () {
    var q = this.tier().qty;
    while (this.selections.length < q) this.selections.push(this.selections[this.selections.length - 1] || this.defaultVariant.id);
    this.selections.length = q;
  };
  ProductForm.prototype.unitPrice = function () {
    var v = this.variantById(this.selections[0]) || this.defaultVariant;
    return v.price;
  };
  ProductForm.prototype.totals = function (tier, selections) {
    var self = this, sum = 0, compare = 0;
    for (var i = 0; i < tier.qty; i++) {
      var v = self.variantById(selections[i]) || self.defaultVariant;
      sum += v.price;
      compare += Math.max(v.compare_at_price || 0, v.price);
    }
    var discount = tierDiscount(tier, (self.variantById(selections[0]) || self.defaultVariant).price);
    return { total: sum - discount, compare: compare, save: compare - (sum - discount), discount: discount };
  };
  ProductForm.prototype.render = function () {
    var self = this;
    this.cards.forEach(function (card, i) {
      var tier = self.tiers[i];
      var sel = i === self.tierIndex ? self.selections : fillFor(tier.qty);
      var t = self.totals(tier, sel);
      card.classList.toggle('is-selected', i === self.tierIndex);
      var tot = $('[data-tier-total]', card), cmp = $('[data-tier-compare]', card), save = $('[data-tier-save]', card), each = $('[data-tier-each]', card);
      if (tot) tot.textContent = formatMoney(t.total);
      if (cmp) { cmp.textContent = t.compare > t.total ? formatMoney(t.compare) : ''; }
      if (save) { save.hidden = !(t.save > 0); save.textContent = 'Save ' + formatMoney(t.save); }
      if (each) { each.hidden = tier.qty < 2; each.textContent = formatMoney(Math.round(t.total / tier.qty)) + ' each'; }
      var pick = $('[data-tier-pickers]', card);
      if (pick) pick.innerHTML = (i === self.tierIndex && self.hasVariants) ? self.pickersHTML() : '';
    });
    function fillFor(q) { var a = []; for (var k = 0; k < q; k++) a.push(self.selections[k] || self.selections[0] || self.defaultVariant.id); return a; }
    this.bindPickers();
    var cur = this.totals(this.tier(), this.selections);
    var unitV = this.variantById(this.selections[0]) || this.defaultVariant;
    if (this.priceNow) this.priceNow.textContent = formatMoney(unitV.price);
    if (this.priceWas) this.priceWas.textContent = unitV.compare_at_price > unitV.price ? formatMoney(unitV.compare_at_price) : '';
    if (this.priceOff) {
      var pct = unitV.compare_at_price > unitV.price ? Math.floor((unitV.compare_at_price - unitV.price) * 100 / unitV.compare_at_price) : 0;
      this.priceOff.hidden = pct <= 0; this.priceOff.textContent = pct + '% off';
    }
    var anyUnavailable = this.selections.some(function (id) { var v = self.variantById(id); return !v || !v.available; });
    if (this.atc) {
      this.atc.disabled = anyUnavailable;
      if (this.atcLabel) this.atcLabel.textContent = anyUnavailable ? 'Sold out' : (this.tier().qty > 1 ? 'Add ' + this.tier().qty + ' to bag' : 'Add to bag');
      if (this.atcPrice) this.atcPrice.textContent = anyUnavailable ? '' : formatMoney(cur.total);
    }
    if (this.sticky) {
      var st = $('[data-sticky-title]', this.sticky), sp = $('[data-sticky-price]', this.sticky), si = $('[data-sticky-thumb]', this.sticky), sbtn = $('[data-sticky-add]', this.sticky);
      if (st) st.textContent = (this.tiers[this.tierIndex] && this.tiers[this.tierIndex].label) || this.data.title;
      if (sp) sp.textContent = formatMoney(cur.total);
      if (si && unitV.image) si.src = unitV.image;
      if (sbtn) sbtn.disabled = anyUnavailable;
    }
  };
  ProductForm.prototype.swatchStyle = function (v) {
    var c = this.swatches[(v.option1 || '').toLowerCase()];
    if (c) return '--sw:' + c;
    return v.image ? "background-image:url('" + v.image + "')" : '';
  };
  ProductForm.prototype.pickersHTML = function () {
    var self = this, out = '';
    this.selections.forEach(function (id, u) {
      var cur = self.variantById(id) || self.defaultVariant;
      var label = self.tier().qty > 1 ? self.unitLabel + ' ' + (u + 1) : self.optionName;
      out += '<div class="mb-pick" role="group" aria-label="' + esc(label + ' ' + self.optionName) + '">' +
        '<img class="mb-pick__thumb" src="' + esc(cur.image || '') + '" alt="' + esc(cur.title) + '" width="52" height="52" loading="lazy">' +
        '<span class="mb-pick__label">' + esc(label) + ': <strong>' + esc(cur.option1 || cur.title) + '</strong></span>' +
        '<div class="mb-swatches">';
      self.variants.forEach(function (v) {
        out += '<button type="button" class="mb-swatch" data-unit="' + u + '" data-variant="' + v.id + '" style="' + esc(self.swatchStyle(v)) + '" aria-pressed="' + (String(v.id) === String(id)) + '" aria-label="' + esc((v.option1 || v.title) + (v.available ? '' : ', sold out')) + '"' + (v.available ? '' : ' disabled') + '></button>';
      });
      out += '</div></div>';
    });
    return out;
  };
  ProductForm.prototype.bindPickers = function () {
    var self = this;
    $$('.mb-swatch', this.root).forEach(function (b) {
      b.addEventListener('click', function () {
        var u = Number(b.getAttribute('data-unit'));
        self.selections[u] = Number(b.getAttribute('data-variant'));
        var v = self.variantById(self.selections[u]);
        self.render();
        var again = self.root.querySelector('.mb-swatch[data-unit="' + u + '"][data-variant="' + b.getAttribute('data-variant') + '"]');
        if (again) again.focus();
        if (self.gallery && v && v.media_id) self.gallery.goToMedia(v.media_id);
      });
    });
  };
  ProductForm.prototype.watchSticky = function () {
    var self = this;
    if (!('IntersectionObserver' in window) || !this.atc) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        self.sticky.classList.toggle('is-visible', past);
        self.sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      });
    });
    io.observe(this.atc);
  };
  ProductForm.prototype.add = function () {
    var self = this;
    var counts = {}, order = [];
    this.selections.forEach(function (id) { if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++; });
    var items = order.map(function (id) { return { id: Number(id), quantity: counts[id] }; });
    var btns = [this.atc, this.sticky && $('[data-sticky-add]', this.sticky)].filter(Boolean);
    btns.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    if (this.error) this.error.textContent = '';
    return fetch(routes.cart_add, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'This item could not be added. Please try again.'); return j; });
    }).then(function () { return Cart.refresh(); })
      .then(function () { Cart.open(self.atc); })
      .catch(function (err) { if (self.error) self.error.textContent = err.message; })
      .then(function () { btns.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); });
  };

  /* ---------- Cart drawer ---------- */
  var Cart = {
    el: null, cart: null, lastFocus: null,
    init: function () {
      this.el = document.getElementById('CartDrawer');
      if (!this.el) return;
      var self = this;
      this.body = $('[data-cart-body]', this.el);
      this.foot = $('[data-cart-foot]', this.el);
      this.err = $('[data-cart-error]', this.el);
      this.live = $('[data-cart-live]', this.el);
      $$('[data-cart-close]', this.el).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      $$('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); self.refresh().then(function () { self.open(b); }); });
      });
      document.addEventListener('keydown', function (e) {
        if (!self.el.classList.contains('is-open')) return;
        if (e.key === 'Escape') self.close();
        if (e.key === 'Tab') self.trap(e);
      });
      this.body.addEventListener('click', function (e) {
        var b = e.target.closest('[data-line-change]');
        if (!b) return;
        self.change(Number(b.getAttribute('data-line')), Number(b.getAttribute('data-qty')));
      });
    },
    trap: function (e) {
      var f = $$('a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])', $('.mb-drawer__panel', this.el)).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    },
    open: function (from) {
      if (!this.el) { window.location.href = (M.routes && M.routes.cart_page) || '/cart'; return; }
      this.lastFocus = from || document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mb-lock');
      var c = $('[data-cart-close].mb-icon-btn', this.el);
      setTimeout(function () { if (c) c.focus(); }, 60);
    },
    close: function () {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mb-lock');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    refresh: function () {
      var self = this;
      return fetch(routes.cart, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.cart = c; self.render(); return c; });
    },
    change: function (line, quantity) {
      var self = this;
      if (this.err) this.err.textContent = '';
      this.body.classList.add('is-busy');
      return fetch(routes.cart_change, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Your bag could not be updated.'); return j; });
      }).then(function (c) { self.cart = c; self.render(); if (self.live) self.live.textContent = 'Bag updated. ' + c.item_count + ' items.'; })
        .catch(function (e) { if (self.err) self.err.textContent = e.message; return self.refresh(); })
        .then(function () { self.body.classList.remove('is-busy'); });
    },
    render: function () {
      var c = this.cart; if (!c || !this.el) return;
      $$('[data-cart-count]').forEach(function (n) { n.textContent = c.item_count; n.setAttribute('data-count', c.item_count); });
      var countEl = $('[data-cart-heading-count]', this.el); if (countEl) countEl.textContent = c.item_count ? '(' + c.item_count + ')' : '';
      if (!c.items.length) {
        this.body.innerHTML = $('[data-cart-empty-tpl]', this.el).innerHTML;
        this.foot.hidden = true;
        return;
      }
      this.foot.hidden = false;
      var html = '';
      c.items.forEach(function (it, i) {
        var line = i + 1;
        var img = it.image ? (it.image.indexOf('data:') === 0 ? it.image : it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=180') : '';
        var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        var discs = (it.line_level_discount_allocations || []).map(function (d) {
          return '<div class="mb-line__disc">' + esc(d.discount_application && d.discount_application.title || 'Discount') + ' (−' + formatMoney(d.amount) + ')</div>';
        }).join('');
        html += '<div class="mb-line">' +
          (img ? '<img class="mb-line__img" src="' + esc(img) + '" alt="' + esc(it.product_title) + '" width="76" height="76" loading="lazy">' : '<span class="mb-line__img" aria-hidden="true"></span>') +
          '<div><div class="mb-line__title">' + esc(it.product_title) + '</div>' +
          (vt ? '<div class="mb-line__variant">' + esc(vt) + '</div>' : '') + discs +
          '<div class="mb-line__controls"><div class="mb-qty" role="group" aria-label="Quantity for ' + esc(it.product_title + (vt ? ', ' + vt : '')) + '">' +
          '<button type="button" data-line-change data-line="' + line + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
          '<span aria-live="polite">' + it.quantity + '</span>' +
          '<button type="button" data-line-change data-line="' + line + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="mb-line__remove" data-line-change data-line="' + line + '" data-qty="0">Remove</button></div></div>' +
          '<div class="mb-line__price">' + (it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '') + formatMoney(it.final_line_price) + '</div>' +
          '</div>';
      });
      this.body.innerHTML = html;
      var orig = $('[data-cart-original]', this.el), save = $('[data-cart-savings]', this.el), saveRow = $('[data-cart-savings-row]', this.el), total = $('[data-cart-total]', this.el);
      var cartLevel = (c.cart_level_discount_applications || []).reduce(function (a, d) { return a + (d.total_allocated_amount || 0); }, 0);
      var totalDiscount = (c.total_discount != null ? c.total_discount : (c.original_total_price - c.total_price));
      if (orig) orig.textContent = formatMoney(c.original_total_price);
      if (saveRow) saveRow.hidden = !(totalDiscount > 0);
      if (save) save.textContent = '−' + formatMoney(totalDiscount);
      if (total) total.textContent = formatMoney(c.total_price);
      this.checkOffer(c, totalDiscount, cartLevel);
    },
    // Compare the advertised bundle offer with the discount Shopify actually returned.
    checkOffer: function (c, applied) {
      var flag = $('[data-cart-flag]', this.el);
      var tiers = (M.bundle && M.bundle.tiers) || [];
      if (!tiers.length) return;
      var qty = c.items.reduce(function (a, it) { return a + it.quantity; }, 0);
      var unit = c.items.length ? c.items[0].original_price : 0;
      var expected = expectedDiscount(tiers, qty, unit);
      var mismatch = Math.abs(expected - applied) > 1;
      this.el.setAttribute('data-offer-mismatch', mismatch ? 'true' : 'false');
      if (mismatch) {
        if (window.console) console.warn('[Mewbie] Bundle offer mismatch: advertised ' + formatMoney(expected) + ' off for ' + qty + ' items, Shopify applied ' + formatMoney(applied) + '. Check Discounts in Shopify admin.');
        if (flag && (M.designMode || M.showMismatch)) {
          flag.textContent = 'Offer check: for ' + qty + ' items the bundle promises ' + formatMoney(expected) + ' off, but Shopify applied ' + formatMoney(applied) + '. ' + (M.designMode ? 'Set up the automatic discounts described in the install guide.' : 'Final pricing is confirmed at checkout.');
        }
      } else if (flag) { flag.textContent = ''; }
    }
  };
  M.Cart = Cart;

  /* ---------- Announcement rotator ---------- */
  function Announce(root) {
    var msgs = $$('[data-announce-msg]', root);
    if (msgs.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, paused = false;
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    setInterval(function () {
      if (paused) return;
      msgs[i].hidden = true; i = (i + 1) % msgs.length; msgs[i].hidden = false;
    }, 4500);
  }

  function boot() {
    $$('[data-gallery]').forEach(function (g) { var gal = new Gallery(g); var host = g.closest('[data-product-root]'); if (host) host.__gallery = gal; });
    $$('[data-product-root]').forEach(function (r) { r.__form = new ProductForm(r); });
    $$('[data-announce]').forEach(function (a) { Announce(a); });
    Cart.init();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { boot(); });
})();
